export const ADD_DISCOVER_DATA = 'ADD_DISCOVER_DATA';
export const UPDATE_DISCOVER_DATA = 'UPDATE_DISCOVER_DATA';
export const INIT_CATEGORY_DATA = 'INIT_CATEGORY_DATA';
